<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    name: 'HomeView',
    data() {
        return {

        }
    },
    // 组件
    components: {
    },
    async created() {

    },
    async mounted(){   
    }
}
</script>
<style>
</style>
